var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/error_boundary.tsx";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getSoapboxConfig } from 'soapbox/actions/soapbox';
import * as BuildConfig from 'soapbox/build_config';
import { Text, Stack } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
import KVStore from 'soapbox/storage/kv_store';
import sourceCode from 'soapbox/utils/code';
const goHome = () => location.href = '/';

/** Unregister the ServiceWorker */
// https://stackoverflow.com/a/49771828/8811886
const unregisterSw = async () => {
  if (navigator.serviceWorker) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const unregisterAll = registrations.map(r => r.unregister());
    await Promise.all(unregisterAll);
  }
};
const mapStateToProps = state => {
  const {
    links,
    logo
  } = getSoapboxConfig(state);
  return {
    siteTitle: state.instance.title,
    logo,
    links
  };
};
class ErrorBoundary extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hasError: false,
      error: undefined,
      componentStack: undefined,
      browser: undefined
    });
    _defineProperty(this, "textarea", null);
    _defineProperty(this, "setTextareaRef", c => {
      this.textarea = c;
    });
    _defineProperty(this, "handleCopy", () => {
      if (!this.textarea) return;
      this.textarea.select();
      this.textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
    });
    _defineProperty(this, "getErrorText", () => {
      const {
        error,
        componentStack
      } = this.state;
      return error + componentStack;
    });
    _defineProperty(this, "clearCookies", e => {
      localStorage.clear();
      sessionStorage.clear();
      KVStore.clear();
      if ('serviceWorker' in navigator) {
        e.preventDefault();
        unregisterSw().then(goHome).catch(goHome);
      }
    });
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error,
      componentStack: info && info.componentStack
    });
    import(/* webpackChunkName: "error" */'bowser').then(({
      default: Bowser
    }) => {
      this.setState({
        browser: Bowser.getParser(window.navigator.userAgent)
      });
    }).catch(() => {});
  }
  render() {
    const {
      browser,
      hasError
    } = this.state;
    const {
      children,
      siteTitle,
      logo,
      links
    } = this.props;
    if (!hasError) {
      return children;
    }
    const isProduction = BuildConfig.NODE_ENV === 'production';
    const errorText = this.getErrorText();
    return /*#__PURE__*/React.createElement("div", {
      className: "h-screen pt-16 pb-12 flex flex-col bg-white",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("main", {
      className: "flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 115,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-shrink-0 flex justify-center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "/",
      className: "inline-flex",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 13
      }
    }, logo ? /*#__PURE__*/React.createElement("img", {
      className: "h-12",
      src: logo,
      alt: siteTitle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 17
      }
    }) : /*#__PURE__*/React.createElement(SvgIcon, {
      className: "h-12 w-12",
      src: require('@tabler/icons/home.svg'),
      alt: siteTitle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 17
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "py-8",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-center max-w-xl mx-auto space-y-2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 128,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.message",
      defaultMessage: "Something went wrong.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 129,
        columnNumber: 17
      }
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-lg text-gray-500",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.body",
      defaultMessage: "We're sorry for the interruption. If the problem persists, please reach out to our support team. You may also try to {clearCookies} (this will log you out).",
      values: {
        clearCookies: /*#__PURE__*/React.createElement("a", {
          href: "/",
          onClick: this.clearCookies,
          className: "text-gray-700 hover:underline",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 136,
            columnNumber: 21
          }
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "alert.unexpected.clear_cookies",
          defaultMessage: "clear cookies and browser data",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 137,
            columnNumber: 23
          }
        }))
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 17
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "medium",
      tag: "span",
      theme: "muted",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 17
      }
    }, sourceCode.displayName, ":"), ' ', sourceCode.version), /*#__PURE__*/React.createElement("div", {
      className: "mt-10",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "/",
      className: "text-base font-medium text-primary-600 hover:text-primary-500",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.return_home",
      defaultMessage: "Return Home",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 19
      }
    }), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 19
      }
    }, " \u2192")))), !isProduction && /*#__PURE__*/React.createElement("div", {
      className: "py-16 max-w-lg mx-auto space-y-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 161,
        columnNumber: 15
      }
    }, errorText && /*#__PURE__*/React.createElement("textarea", {
      ref: this.setTextareaRef,
      className: "h-48 p-4 shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md font-mono",
      value: errorText,
      onClick: this.handleCopy,
      readOnly: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 19
      }
    }), browser && /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 173,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "semibold",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.browser",
      defaultMessage: "Browser",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 45
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 21
      }
    }, browser.getBrowserName(), " ", browser.getBrowserVersion()))))), /*#__PURE__*/React.createElement("footer", {
      className: "flex-shrink-0 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("nav", {
      className: "flex justify-center space-x-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 11
      }
    }, links.get('status') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: links.get('status'),
      className: "text-sm font-medium text-gray-500 hover:text-gray-600",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 187,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.links.status",
      defaultMessage: "Status",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 19
      }
    }))), links.get('help') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "inline-block border-l border-gray-300",
      "aria-hidden": "true",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 195,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("a", {
      href: links.get('help'),
      className: "text-sm font-medium text-gray-500 hover:text-gray-600",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.links.help",
      defaultMessage: "Help Center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 19
      }
    }))), links.get('support') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "inline-block border-l border-gray-300",
      "aria-hidden": "true",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("a", {
      href: links.get('support'),
      className: "text-sm font-medium text-gray-500 hover:text-gray-600",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 205,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "alert.unexpected.links.support",
      defaultMessage: "Support",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 19
      }
    }))))));
  }
}
export default connect(mapStateToProps)(ErrorBoundary);